<template>
	<div class="">
		<div v-if="!start">
			<div class="live"><VTcPlayer ref="tcPlayer" :options="options" elmId="1" @load="onLoad" @play="onPlay" @pause="onPause" /></div>
			<div class="gds-info f-ac f-jsb">
				<div class="f-ac">
					<img :src="img" alt="" />
					<div class="clamp-1">{{title}}</div>
				</div>
				<div class="but">
					<a class="btn-a" :href="href" rel="external nofollow">购买商品</a>
				</div>
			</div>
		</div>
		<div class="awa f-ajc" v-else>
			<div style="text-align: center;">
				<div class="">
					<img src="https://image.soole.com.cn/logo.png" alt="">
				</div>
				<div class="tip">直播已结束</div>
				<div class="but">
					<a class="btn-a" :href="href" rel="external nofollow">查看更多</a>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
import { VTcPlayer } from 'v-tcplayer';
//脚手架配置了alias
import linkedmeLink from './linkedme.js';
export default {
	data() {
		return {
			options: {},
			woptions: {},
			isaa: false,
			dapingshow: true,
			clientHeight: 0,
			href: '',
			m3u8:"",
			title:"",
			img:"",
			start:false,
		};
	},

	components: {
		VTcPlayer
	},

	computed: {},

	created() {
		//获取参数
		// var url = "https: //zhidao.baidu.com/question/1768422895052400180.html?fr=iks&word=slice&ie=gbk";
		
		var url = window.location.search;
		var params = this.$util.UrlParamHash(url);
		console.log(params);
		console.log(!params['url']);
		if(!params['url']){
			this.start = true;
			return;
		}
		this.m3u8 = params['url'];
		this.title =  decodeURI(params['title']);
		this.img = params['img'];
		
		this.clientHeight = document.body.clientHeight;
		this.getonmessage();
	},
	mounted() {
		var u = navigator.userAgent,
			app = navigator.appVersion;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
		var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		console.log('是否是Android：' + isAndroid);
		console.log('是否是iOS：' + isiOS);
		if (isAndroid) {
			this.href = 'http://imtt.dd.qq.com/16891/apk/A7B94F5290CDAD229FCD35A145993A82.apk?fsname=com.sole.ecology_2.5.0_150.apk&hsr=4d5s';
		} else {
			this.href = 'https://itunes.apple.com/cn/app/ id1456076603?mt=8';
		}
	},

	methods: {
		// 视频加载
		onLoad() {},
		// 视频点击播放
		onPlay() {},
		// 视频点击暂停
		onPause() {},

		// 视频地址存放
		getonmessage() {
			let obj = {
				hlsUrl: 'https://lib.baomitu.com/hls.js/0.8.9/hls.min.js',
				width: '100%',
				height: this.clientHeight - 100 + '',
				autoplay: true,
				// m3u8: 'http://wxplay.soole.com.cn/live/tpc.m3u8',
				// flv: 'http://play.soole.com.cn/live/1400331236_YM1261964.flv',
				m3u8: this.m3u8
			};
			this.options = obj;
		},
		
	}
};
</script>

<style lang="less" scoped>
.live {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
	width: 100%;
	// background-color: #000080;
}
.gds-info {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 10px 10px;
	// background-color: rgba(0,0,0,0.1);
	height: 100px;
	box-sizing: border-box;
	img {
		width: 80px;
		// height: 80px;
		margin-right: 10px;
	}
}

.but {
	flex-shrink: 0;
	a {
		background-color: #f84447;
		color: #ffffff;
		display: inline-block;
		border-radius: 5px;
		padding: 10px 15px;
	}
}
.awa{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,.3);
	z-index: 10;
	color: #FFFFFF;
	img{
		width: 60px;
	}
	.tip{
		margin: 10px 0;
		font-size: 18px;
	}
}
</style>



// WEBPACK FOOTER //
// src/page/live/index.vue